import { Listing } from "./listing";
import { Agent } from "./agent";
import { Office } from "./office";

export const RECAPTCHA_HEADER = 'recaptcha-key';

export const emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const nameRegex: RegExp =  /^[a-zA-Z ]+$/

export const MapOfficeToLead = (office: Office): Partial<RemaxLeadEntity> => {
  return {
    triggerType: LeadTrigger.ContactOffice,
    officeInfo: {
      legacyRemaxId: office.legacyRemaxId,
      personifyId: String(office.personifyId),
      sourceSystemId: office.sourceSystemId,
      sourceSystem: office.sourceSystem,
    }
  };
}

export const MapAgentToLead = (agent: Agent): Partial<RemaxLeadEntity> => {
  return {
    triggerType: LeadTrigger.ContactAgent,
    agentInfo: {
      email: agent.email,
      name: agent.fullName,
      personifyId: agent.personifyId,
      remaxOfficeId: String(agent.remaxOfficeId),
      sourceOfficeId: agent.officeId,
      sourceSystemId: agent.sourceSystemId,
      sourceSystem: agent.sourceSystem,
      postalCode: agent.postalCode,
      isFavouriteAgent: agent.isFavourite
    }
  };
}

export const MapListingToListingInfo = (listing: Listing): ListingInformation => {
  return {
    listingId: listing.listingId,
    isRemaxListing: listing.isRemaxListing,
    remaxAgentId: listing.remaxAgentId,
    remaxCoAgentId: listing.remaxCoAgentId,
    remaxOfficeId: listing.remaxOfficeId,
    mlsNum: listing.mlsNum,
    listingSourceId: listing.source,
    listingType: String(listing.listingTypeId),
    url: listing.detailUrl,
    price: listing.listPrice || listing.pricePerSqFt,
    address: {
      street: listing.address,
      city: listing.city,
      state: listing.province,
      stateShort: listing.province,
      postalCode: listing.postalCode,
      country: listing.country,
    }
  };
}

export interface RemaxLeadEntity
{
  triggerType: LeadTrigger;
  contactInfo: ContactInformation;
  contactPref?: ContactPreferences;
  listingInfo?: ListingInformation;
  agentInfo?: AgentInformation;
  coAgentInfo?: AgentInformation;
  officeInfo?: OfficeInformation;
  weeklyAvailability ?: WeeklyAvailability;
  comments?: string;
}

export interface WeeklyAvailability {
  weekend?: DailyAvailability;
  weekday?: DailyAvailability;
}

export interface DailyAvailability {
  morning?: boolean;
  afternoon?: boolean;
  evening?: boolean;
}

export interface OfficeInformation
{
  personifyId?: string;
  legacyRemaxId?: string;
  sourceSystemId?: string;
  sourceSystem?: string;
  postalCode?: string;
}

export interface AgentInformation
{
  personifyId?: string;
  sourceSystemId?: string;
  name?: string;
  email?: string;
  remaxOfficeId?: string;
  sourceOfficeId?: string;
  sourceSystem?: string;
  postalCode?: string;
  isFavouriteAgent?: boolean;
}

export interface ListingInformation
{
  listingId?: string;
  isRemaxListing?: boolean;
  remaxAgentId?: string;
  remaxCoAgentId?: string;
  remaxOfficeId?: string;
  mlsNum?: string;
  listingSourceId?: string;
  listingType?: string;
  url?: string;
  price?: number;
  address?: AddressInfo;
}

export interface AddressInfo
{
  street?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  stateShort?: string;
}

export interface ContactPreferences
{
  email?: boolean;
  telephone?: boolean;
}

export interface ContactInformation
{
  name: string;
  email: string;
  businessPhone?: string;
  homePhone?: string;
}

export enum LeadTrigger
{
  // EmailAFriend = 8,
  // ScheduleShowing = 5,
  RequestInfo = 6,
  ContactAgent = 7,
  // Referral = 3,
  // SignCallIn = 2,
  ContactOffice = 10,
  // OpenHouseRsvp = 11,
  // SaveToMobile = 12,
  // Recruitment = 13,
  // Other = 4,
  // NULL = -1,
  // Unknown = 21
}
